module.exports = __webpack_public_path__ + "img/startCreate3.723a88fe.webp";